<template>
  <v-dialog v-model="showDialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs"/>
    </template>
    <v-card>
      <v-card-title>{{ $t('upload_route_plan') }}</v-card-title>
      <v-card-text class="d-flex align-center">
        <v-file-input v-model="uploadFile" :placeholder="$tc('select_a_file')" class="mr-1" :error-messages="errors"/>
        <v-btn fab text :loading="isUploading" color="primary" @click="fileUpload()">
          <v-icon>mdi-upload</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationMixin from '@/components/mixins/ValidationMixin'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'UploadRoutePlanDialog',
  mixins: [
    ValidationMixin
  ],
  data () {
    return {
      showDialog: false,
      uploadFile: null,
      isUploading: false
    }
  },
  validations: {
    uploadFile: {
      required
    }
  },
  methods: {
    /**
     * Upload the provided route plan file
     */
    async fileUpload () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }
      this.isUploading = true
      try {
        const formData = new FormData()
        formData.append('file', this.uploadFile)
        await this.$httpAdapter({
          headers: { 'Content-Type': 'multipart/form-data' },
          url: this.$orm('RoutePlan').endpoint + '/upload',
          method: 'POST',
          data: formData
        })
        await this.$store.dispatch(
          'globalMessagingModule/showSuccessFlashBanner',
          this.$tc('route_plan_file_upload_success')
        )
        this.showDialog = false
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isUploading = false
      }
    }
  },
  computed: {
    errors () {
      return this.validationError({
        prop: this.$v.uploadFile,
        message: this.$t('required')
      })
    }
  }
}
</script>
